import type { LevelIconName } from "../../icon";
import Box from "../Box";
import TooltipWrapper from "../TooltipWrapper";
import LockedOptionsBanner from "./LockedOptionsBanner";
import OptionListItem from "./OptionListItem";

export type OptionListOption = {
	id: string;
	label: string;
	icon?: LevelIconName;
	iconColor?: string;
	countLabel?: string;
	checked?: boolean;
	disabled?: boolean;
	/** Zero items available — renders the tooltip explaining why it cannot be picked. */
	unavailable?: boolean;
};

type Props = {
	options: OptionListOption[];
	unavailableTooltip?: string;
	bannerLabel?: string;
	onPressBanner?: () => void;
	disabled?: boolean;
	onToggle: (id: string) => void;
};

const OptionList = ({
	options,
	unavailableTooltip,
	bannerLabel,
	onPressBanner,
	disabled,
	onToggle,
}: Props) => (
	<Box gap={2}>
		{options.map((option) => {
			const row = (
				<OptionListItem
					id={option.id}
					label={option.label}
					icon={option.icon}
					iconColor={option.iconColor}
					countLabel={option.countLabel}
					checked={option.checked}
					disabled={option.disabled || option.unavailable || disabled}
					onToggle={onToggle}
				/>
			);

			if (option.unavailable && unavailableTooltip) {
				return (
					<TooltipWrapper
						key={option.id}
						title={unavailableTooltip}
						display="block"
						style={{ cursor: "not-allowed" }}
					>
						{row}
					</TooltipWrapper>
				);
			}

			return <Box key={option.id}>{row}</Box>;
		})}
		{bannerLabel && onPressBanner ? (
			<LockedOptionsBanner
				label={bannerLabel}
				onPress={onPressBanner}
				disabled={disabled}
				testID="locked-options-banner"
			/>
		) : null}
	</Box>
);

export default OptionList;
